import type { ParsedFile, RawRow } from '@/features/parties/import/lib/types';
import type { JobRow } from './types';

/** Read the first present (case-insensitive) key from a row, trimmed. */
function pick(row: RawRow, ...keys: string[]): string {
  const lowerKeys = Object.keys(row);
  for (const k of keys) {
    const hit = lowerKeys.find((rk) => rk.toLowerCase() === k.toLowerCase());
    if (hit && row[hit]) return row[hit]!.trim();
  }
  return '';
}

/** `"-18C"` → -18, `"2C"` → 2, `"Ambient"` / blank → null. */
export function parseTemperature(raw: string): number | null {
  if (!raw) return null;
  const m = raw.match(/-?\d+(?:\.\d+)?/);
  return m ? Number(m[0]) : null;
}

function parseQuantity(raw: string): number | null {
  if (!raw) return null;
  const n = Number(raw.replace(/[^\d.-]/g, ''));
  return Number.isFinite(n) ? n : null;
}

/** Map one raw row to a {@link JobRow}, tolerating a few header aliases. */
export function rowToJob(row: RawRow): JobRow {
  return {
    jobRef: pick(row, 'JobRef', 'Reference', 'Ref'),
    accountCode: pick(row, 'AccountCode', 'CustomerCode', 'Code'),
    clientName: pick(row, 'ClientName', 'Customer', 'CustomerName'),
    collectionAddress: pick(row, 'CollectionAddress'),
    collectionDate: pick(row, 'CollectionDate'),
    collectionTime: pick(row, 'CollectionTime'),
    deliveryAddress: pick(row, 'DeliveryAddress'),
    deliveryDate: pick(row, 'DeliveryDate'),
    deliveryTime: pick(row, 'DeliveryTime'),
    itemType: pick(row, 'ItemType', 'CargoType'),
    quantity: parseQuantity(pick(row, 'Quantity', 'Qty')),
    temperatureC: parseTemperature(pick(row, 'Temperature', 'Temp')),
    notes: pick(row, 'Notes'),
  };
}

export function parseJobs(parsed: ParsedFile): JobRow[] {
  return parsed.rows.map(rowToJob);
}
